"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Cluster_1 = __importDefault(require("./Cluster"));
class ClusterList {
    constructor(num_clusters, name = null) {
        this.name = null;
        this.clusters = [];
        this.clusters = [];
        for (let i = 0; i < num_clusters; i++) {
            this.clusters.push(new Cluster_1.default(i));
        }
        this.name = name;
    }
    addSample(sample, cluster_idx) {
        this.clusters.forEach(cluster => cluster.rm(sample));
        if (cluster_idx !== null) {
            this.clusters[cluster_idx].add(sample);
        }
        this.name = null;
    }
    get length() {
        return this.clusters.length;
    }
    get filled_clusters() {
        return this.clusters.filter(c => c.samples.length).length;
    }
    get hasWarning() {
        return this.clusters.some((cluster) => cluster.hasWarnings);
    }
    all() {
        return this.clusters;
    }
    getClusterIdx(sample) {
        for (let c of this.clusters) {
            for (let s of c.samples) {
                if (sample.id === s.id)
                    return c.idx;
            }
        }
        return null;
    }
    get ready() {
        let filled_clusters = 0;
        for (const cluster of this.clusters) {
            if (cluster.samples.length > 0)
                filled_clusters++;
        }
        return filled_clusters > 1;
    }
    get empty() {
        for (const cluster of this.clusters) {
            if (cluster.samples.length > 0)
                return false;
        }
        return true;
    }
    toPayload() {
        return this.clusters.map(c => {
            return c.samples.map(s => s.code);
        });
    }
    toSavePayload() {
        let last_cluster_filled = -1;
        const clusters = this.clusters.map((c, i) => {
            if (c.samples.length && i > last_cluster_filled)
                last_cluster_filled = i;
            return {
                name: c.name,
                samples: c.samples.map(s => s.code),
            };
        });
        return clusters.slice(0, last_cluster_filled + 1);
    }
}
exports.default = ClusterList;
